(function() {
    if (window.__grStickyATCInit) return;
    window.__grStickyATCInit = true;

    function init() {                    
      var bar = document.querySelector('product-quick-add') || document.querySelector('.product-quick-add');
      var atc = document.querySelector('buy-buttons');                                                                                        
      if (!bar || !atc) return;               
                                                                                                                                              
      function checkPosition() {
        var rect = atc.getBoundingClientRect();                                                                                               
        var inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
        if (inView) {                                                                                                                         
          bar.classList.remove('is-visible'); 
        } else {                          
          bar.classList.add('is-visible');
        }                                                                                                                                     
      }
                                                                                                                                              
      setTimeout(checkPosition, 300);
      setTimeout(checkPosition, 800);
      setTimeout(checkPosition, 1500);
                                              
      window.addEventListener('scroll', checkPosition, { passive: true });
      window.addEventListener('touchmove', checkPosition, { passive: true });
      window.addEventListener('touchend', checkPosition, { passive: true });                                                                  
   
      var stickyBtn = bar.querySelector('button, .btn, [type="submit"], .quick-add__submit');                                                     
  if (stickyBtn) {                        
    stickyBtn.addEventListener('click', function(e) {                                                                                         
      e.preventDefault();                                                                                                                     
      e.stopPropagation();                                                                                                                    
      var target = document.querySelector('.product-info__buy-buttons') || atc;                                                               
      var rect = target.getBoundingClientRect();
      var top = rect.bottom + window.scrollY - window.innerHeight + 16;                                                                       
      window.scrollTo({ top: top, behavior: 'smooth' });
    });                                                                                                                                       
  }                                                                                                                                       
    }                                                                                                                                         
   
    if (document.readyState === 'loading') {                                                                                                  
      document.addEventListener('DOMContentLoaded', init);
    } else {                                  
      init();                             
    }
  })();